jQuery(document).ready(function(){
  /****************https://3tandai.com/pages/verification/ [Show second hide first]**************************/
  jQuery(document).on("click", ".next-show-prev-hide .form2next", function(stop){
    var globVal = jQuery(this).closest("form").find("input.understand");
    if(globVal.is(':checked')){
      //alert("globVal " + globVal.val());
      jQuery(this).closest(".get__doller_amet").find(".amet-bsp").addClass("hide-1");
      jQuery(this).addClass("hide-1");
      jQuery(this).closest("form").find(".form2-two.pop-step.pop-step__custom--here").addClass("show-1");
    }else{
      jQuery(this).closest("form").find(".form-part.amet-bsp .form-element.form2two-input .main-box-error.form2-one").addClass("show-1");
      stop.preventDefault()
    }
  });
  /****************https://3tandai.com/pages/verification/ [Show second hide first]**************************/
  jQuery(document).on("change", "div#mc_embed_signup form .mc-field-group.input-group .input__ops", function(){
    if($(this).prop('checked')) {
      jQuery(this).closest("body").find("div#mc_embed_signup form  .mc-field-group_custom__seocnd.form-element .row-full.custom-chops").show();
    }else{
      jQuery(this).closest("body").find("div#mc_embed_signup form  .mc-field-group_custom__seocnd.form-element .row-full.custom-chops").hide();
    }
  });
  /**********************************************verification page***********************/
  var propFirst;
  var propSecond;
  jQuery(document).on("click", "center .continue.form2next.cipate-btn", function(evxfct){
    var ffone = jQuery(this).closest("form").find(".understand");
    var first = jQuery(this).closest("form").find(".mc-field-group_custom__seocnd.form-element .mc-field-group.input-group .input__ops");
    var second = jQuery(this).closest("form").find(".mc-field-group_custom__seocnd.form-element .mc-field-group.input-group .input__dops");
    var ElectrinicSign = $(this).closest("body").find(".mc-field-group_custom__seocnd.form-element .custom-chops .mc-field-group input#mce-MMERGE1").val();
    var ElectrinicDate1 = $(this).closest("body").find(".mc-field-group_custom__seocnd.form-element .custom-chops .mc-field-group.size1of2 .datefield span.subfield.monthfield input").val();
    var ElectrinicDate2 = $(this).closest("body").find(".mc-field-group_custom__seocnd.form-element .custom-chops .mc-field-group.size1of2 .datefield span.subfield.dayfield input").val();
    var ElectrinicDate3 = $(this).closest("body").find(".mc-field-group_custom__seocnd.form-element .custom-chops .mc-field-group.size1of2 .datefield span.subfield.yearfield input").val();
    var vaDate = jQuery(this).closest("form").find("input#mce-MMERGE2-year").val();
    /****************************************first********************************/
    if(first.is(':checked') && second.is(':checked') && ElectrinicSign  != 0 && ElectrinicDate1 != 0 && ElectrinicDate2 != 0 && ElectrinicDate3 != 0){
      // alert(ElectrinicSign+ " " + " " +ElectrinicDate1+ " " + " " +ElectrinicDate2+ " " + " " +ElectrinicDate3);
      $(this).closest("form").find("div#mc_embed_signup_scroll .form2-three.-spoptep .custom-applic01").addClass("show-1");
      $(this).closest("form").find("div#mc_embed_signup_scroll .form2-three.-spoptep .custom-applic").removeClass("show-1");
      $(this).closest(".pop-step__custom--here").addClass("hide-1");
    }else if(first.is(':checked') && ElectrinicSign  != 0 && ElectrinicDate1 != 0 && ElectrinicDate2 != 0 && ElectrinicDate3 != 0 && vaDate == 2018 || vaDate > 2018){
      // alert(ElectrinicSign+ " " + " " +ElectrinicDate1+ " " + " " +ElectrinicDate2+ " " + " " +ElectrinicDate3);
      $(this).closest("form").find(".mc-field-group.size1of2 .MMERGE2-month").addClass("show-1");
      $(this).closest("form").find("div#mc_embed_signup_scroll .form2-two.pop-step.pop-step__custom--here").removeClass("show-1");
      $(this).closest("form").find("div#mc_embed_signup_scroll .form2-two.pop-step.pop-step__custom--here").addClass("hide-1");
      $(this).closest("form").find("div#mc_embed_signup_scroll .form2-three.-spoptep .custom-applic01").addClass("show-1");
      $(this).closest("form").find("div#mc_embed_signup_scroll .form2-three.-spoptep .custom-applic").removeClass("show-1");
      $(this).closest(".pop-step__custom--here").hide();
    }else if(first.is(':checked') && ElectrinicSign  != 0 && ElectrinicDate1 != 0 && ElectrinicDate2 != 0 && ElectrinicDate3 != 0 && vaDate < 2018){
      // alert("data is invalid");
      $(this).closest("form").find(".mc-field-group.size1of2 .MMERGE2-month").addClass("show-1");
      evxfct.preventDefault();
      //           $(this).closest("form").find("div#mc_embed_signup_scroll .form2-three.-spoptep .custom-applic01").addClass("show-1");
      //           $(this).closest("form").find("div#mc_embed_signup_scroll .form2-three.-spoptep .custom-applic").removeClass("show-1");
      $(this).closest(".pop-step__custom--here").hide();
    }else if(first.is(':checked') && ElectrinicSign == 0){
      //alert("Please fill Electroic Signature");
      $(this).closest("form").find("div#mc_embed_signup_scroll .custom-chops .mc-field-group:nth-child(1) span.elo-sign__techs").addClass("show-1");
    }else if(first.is(':checked') && ElectrinicDate1 == 0 && ElectrinicDate2 == 0 && ElectrinicDate3 == 0){
      //alert("Please fill Electroic Signature");
      $(this).closest("form").find("div#mc_embed_signup_scroll .custom-chops .mc-field-group.size1of2 .main-box-error.signature-date").addClass("show-1");
    }else if (second.is(':checked') && !first.is(':checked')){
      $(this).closest("form").find("div#mc_embed_signup_scroll .form2-three.-spoptep .custom-applic01").removeClass("show-1");
      $(this).closest("form").find("div#mc_embed_signup_scroll .form2-three.-spoptep .custom-applic").addClass("show-1");
      $(this).closest(".pop-step__custom--here").addClass("hide-1");
    }
  });
  /****************************************end verification page **********************************/
  jQuery(document).on("click", ".custom-find--all09  .button--back span.button-span-back", function(){
    jQuery(this).closest(".custom-find--all09").removeClass("show-1");
    jQuery(this).closest(".form2-three.-spoptep.qstomizer-step-two").find(".custom-applic01").removeClass("custom-find--all01");
    jQuery(this).closest("form").find(".pop-step__custom--here").removeClass("hide-1");
    jQuery(this).closest("form").find(".pop-step__custom--here").addClass("show-1");
  });
  /***********************agreement section ********************/
  jQuery(document).on("click", "center .continue.form2next.cipate-btn", function(event){
    if(!jQuery(this).closest("form").find(".understand").is(":checked")){
      //alert("please check 'AGREEMENT' point");
      event.preventDefault();
    }
  });
  /***********************agreement section ********************/
  /************************script for Choose an option field **********************/
  var propFirst;
  var propSecond;
  jQuery(document).on("click", "center .continue.form2next.cipate-btn", function(development){
    if(!jQuery(this).closest("form").find(".input__ops").is(":checked") && !jQuery(this).closest("form").find(".input__dops").is(":checked") ){
      jQuery(this).closest("form").find(".choose__an__option").addClass("show-1");
      development.preventDefault();
    }
  });
  /************************script for Choose an option field **********************/
});
$(window).load(function() {
  var duValue;
  var putEValue;
  var winLoc = window.location.href; 
  var newOne = winLoc.split('/?email=');
  //alert(newOne[1]);
  var putEValue = newOne[1];
  var duValue = putEValue.split('?token=');
  var tutOcd = duValue[0];
  var uOpndT = md5(tutOcd);
  jQuery("body").find("div#mc_embed_signup form#mc-embedded-subscribe-form .mc-field-group input#mce-EMAIL").attr("value",duValue[0]);
  jQuery("body").find("div#mc_embed_signup_scroll input#mce-TOKEN").attr("value",uOpndT);
});
/********************************send data***************************/
$(document).on("click", "div#continue_form2next_cipate-btn", function(e){
 // console.log("got " + $('#repstringg').val());
 // e.preventDefault();
  var couponval= jQuery(".form2-three.pop-step .coponn h3#quotee-code").text();
  //alert(couponval);
  $.ajax({
    type: 'POST',
    url: 'https://mandrillapp.com/api/1.0//messages/send.json',
    data: {
      'key': 'VrRLxl3NJOOqAVA8o_GhYw',
      'message': {
        'from_email': 'eatwell@3tandai.com',
        'to': [
          {
            'email': $('input#mce-EMAIL').val(),
            'name': $('input#mce-EMAIL').val(),
            'type': 'to'
          }
        ],
        "headers": {
          "Reply-To":  $('input#mce-EMAIL').val()
        },
        'autotext': 'false',
        'subject': "Welcome to 3TandAi's Free Research Trial",
        //           'html': 'YOUR COUPON CODE IS: '+ $('#mce-COPON').val();
		'html': "<div>Hello,<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Thank you for your interest in 3TandAi Research and for agreeing to participate in our Free Research Trial. We are studying whether our D-Feat program is an effective tool in reversing hallmarks of Type 2 Diabetes. In exchange for participating, you will gain full access to our year-long D-Feat program - a $399 value - for FREE*!</p><p>To get started, please visit https://3tandai.com/products/d-feat, complete the purchase, using this Promo Code <b>" + couponval + "</b> (*please note that you will still be responsible for all relevant taxes as well as the costs of shipping and handling, generally around $30 altogether).</p><p>After placing your order, you'll receive instructions on how to proceed.  You are advised to visit your personal physician to get *current* (less than 30 day old) blood marker results.</p><p>We are thrilled that you are participating in our research and are excited to try and make a difference in your health and life. Please do not hesitate to contact us with any questions: eatwell@3TandAi.com, and please remember that you can withdraw from the study at any time.</p><h4>Thanks for sharing your journey with us!<br />3TandAi</h4></div>"
      },
      success: function (data) {
        $('#success-coupon').show();        
        //$('#mc-embedded-subscribe').click();
        // window.location.href = 'https://3tandai.com/products/d-feat';
        return false;
      }
    }
  });
});


//     jQuery(document).ready(function(){
//       var vaDate;
//       jQuery(document).on("click", "div#continue_form2next_cipate-btn", function(appli){
//         var vaDate = jQuery(this).closest("form").find("input#mce-MMERGE2-year").val();
//         if (vaDate < 2018 ) {
//           appli.preventDefault();
//           $(this).closest("form")
//           alert(vaDate + " chhota hai " );
//           return false;
//         }
//       });
//     });

jQuery(document).ready(function(){
  $("input#mce-MMERGE14").keypress(function (e) {
    //if the letter is not digit then display error and don't type anything
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      //display error message
      $("#errmsg").html("Digits Only").show().fadeOut("slow");
      return false;
    }
  });
  $("input#mce-MMERGE2-day").keypress(function (e) {
    //if the letter is not digit then display error and don't type anything
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      //display error message
      $("#errmsg").html("Digits Only").show().fadeOut("slow");
      return false;
    }
  });
  $("input#mce-MMERGE2-year").keypress(function (e) {
    //if the letter is not digit then display error and don't type anything
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      //display error message
      $("#errmsg").html("Digits Only").show().fadeOut("slow");
      return false;
    }
  });
  $("input#mce-MMERGE2-month").keypress(function (e) {
    //if the letter is not digit then display error and don't type anything
    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      //display error message
      $("#errmsg").html("Digits Only").show().fadeOut("slow");
      return false;
    }
  });
  /*******************Phone Number**********************/
  var gtur;
  jQuery(document).on("change", '.number-box input#mce-MMERGE14', function(eventttt){
    var gtur =  jQuery(this).val();
    //alert(jQuery(this).val());
    jQuery(this).closest("body").find(".uniq--yort").val(gtur);
    // alert("------------" +jQuery("body").find(".uniq--yort").val());
  });
});




